import { Link } from '@lmig/lmds-react-link';
import { FunctionComponent, useState, useContext, useEffect } from 'react';
import { triggerGoal } from 'Utilities/GoalManager';
import { IconRatingsStarUnfilled, IconRatingsStarFilled } from '@lmig/lmds-react-icons';
import { SliderContext } from 'Feature/Slider/SliderContext';
import { ISliderContext } from 'Feature/Slider/Models/Panels';
import KeyContactLink from 'Feature/Slider/Cards/KeyContactLink';
import { Tooltip } from 'Foundation/Common/Tooltip';

export interface IFavoriteSitecoreLink extends ISitecoreLink {}

const SitecoreLink: FunctionComponent<IFavoriteSitecoreLink> = (props: IFavoriteSitecoreLink) => {
  const [favorited, setFavorited] = useState<boolean>(false);
  const sliderContext = useContext<ISliderContext>(SliderContext);

  useEffect(() => {
    if (props.Favoritable && props.TargetId) {
      if (sliderContext.favorites && sliderContext.favorites.indexOf(props.TargetId.toLowerCase()) > -1)
        setFavorited(true);
      else setFavorited(false);
    }
  }, [props.Favoritable, props.TargetId, sliderContext.favorites]);

  const favorite = async (isFavorite: boolean, id: string | undefined) => {
    setFavorited(isFavorite);
    if (isFavorite) {
      await sliderContext.addFavorite(id, '');
    } else {
      await sliderContext.removeFavorite(id);
    }
  };

  return (
    <>
      {props.Url && props.Text && (
        <div className={props.Favoritable ? 'favorites-link' : ''}>
          {props.Favoritable && (
            <>
              {!favorited ? (
                <Tooltip text="Add favorite">
                  <IconRatingsStarUnfilled
                    size="16"
                    color="teal"
                    title=""
                    aria-label="Add favorite"
                    onClick={() => {
                      favorite(true, props.TargetId);
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip text="Remove favorite">
                  <IconRatingsStarFilled
                    size="16"
                    color="teal"
                    title=""
                    aria-label="Remove favorite"
                    onClick={() => {
                      favorite(false, props.TargetId);
                    }}
                  />
                </Tooltip>
              )}
            </>
          )}
          {props.IsKeyContactLink ? (
            <KeyContactLink
              Class={props.Class}
              Target={props.Target}
              TargetId={props.TargetId}
              Text={props.Text}
              SubText={props.SubText}
              Url={props.Url}
              Favoritable={props.Favoritable}
              IsKeyContactLink={props.IsKeyContactLink}
              OnClick={props.OnClick}
            ></KeyContactLink>
          ) : props.Target && props.Target ? (
            <Link
              variant="standalone"
              caretPosition={props.CaretPosition ? props.CaretPosition : 'right'}
              className={props.Class}
              target={props.Target}
              role="link"
              href={props.Url}
              onClick={(e) => {
                e.preventDefault();
                triggerGoal(props.Goal);
                if (props.Target && props.Target !== '') {
                  window.open(props.Url, props.Target);
                } else {
                  window.open(props.Url, '_self');
                }
              }}
            >
              {props.Text}
            </Link>
          ) : (
            <Link
              variant="standalone"
              caretPosition={props.CaretPosition ? props.CaretPosition : 'right'}
              className={props.Class}
              role="link"
              href={props.Url}
              onClick={(e) => {
                e.preventDefault();
                triggerGoal(props.Goal);
                if (props.Target && props.Target !== '') {
                  window.open(props.Url, props.Target);
                } else {
                  window.open(props.Url, '_self');
                }
              }}
            >
              {props.Text}
            </Link>
          )}
        </div>
      )}
    </>
  );
};

export default SitecoreLink;
